"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInputMask = _interopRequireDefault(require("react-input-mask"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));

var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _moment = _interopRequireDefault(require("moment"));

var _excluded = ["onChange", "value", "className", "alwaysShowMask", "showIcon", "inputProps"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MINUTES_OFFSET = 15;
var mask = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
var fullRegexp = /^(?:\d|[01]\d|2[0-3]):[0-5]\d$/;

var getPadded = function getPadded(value) {
  return value >= 10 ? value : "0".concat(value);
};

var formatTimeString = function formatTimeString(hours, minutes) {
  return "".concat(getPadded(hours), ":").concat(getPadded(minutes));
};

var roundedUp = function roundedUp(time, offset) {
  return Math.floor(time.minutes() / offset) * offset;
};

var getInitialTime = function getInitialTime() {
  var date = new Date();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  return formatTimeString(hours, minutes);
};

var isTimeValid = function isTimeValid(value) {
  return fullRegexp.test(value);
};

var isControlledAndValid = function isControlledAndValid(value) {
  var hasExternalValue = !(0, _isNil.default)(value);
  var isValid = (0, _isEmpty.default)(value) || isTimeValid(value);

  if (hasExternalValue && !isValid) {
    throw Error('Wrong time format. Please pass in value with the following format: "hh:mm".');
  }

  return hasExternalValue && isValid;
};

var TimePicker = function TimePicker(props) {
  var onChange = props.onChange,
      value = props.value,
      className = props.className,
      alwaysShowMask = props.alwaysShowMask,
      showIcon = props.showIcon,
      inputProps = props.inputProps,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var initialTime = isControlledAndValid(value) ? value : getInitialTime();

  var _useState = (0, _react.useState)(initialTime),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      timeValue = _useState2[0],
      setTimeValue = _useState2[1]; // Update internal time value from outside when used as a controlled component


  (0, _react.useEffect)(function () {
    if (isControlledAndValid(value)) {
      setTimeValue(value);
      onChange(value);
    }
  }, [value]);

  var handleChangeTime = function handleChangeTime(event) {
    var currentValue = event.target.value;
    setTimeValue(currentValue);

    if (fullRegexp.test(currentValue)) {
      onChange(currentValue);
    }
  };

  var isValid = isTimeValid(timeValue);

  var handleIncrease = function handleIncrease() {
    var time = (0, _moment.default)("2020-01-01 ".concat(timeValue));
    var rounded = roundedUp(time, MINUTES_OFFSET);
    time.minute(rounded).second(0);
    time.add(MINUTES_OFFSET, 'minutes');
    var updatedTimeValue = formatTimeString(time.hours(), time.minutes());
    setTimeValue(updatedTimeValue);
    onChange(updatedTimeValue);
  };

  var handleDecrease = function handleDecrease() {
    var time = (0, _moment.default)("2020-01-01 ".concat(timeValue));
    var rounded = roundedUp(time, MINUTES_OFFSET);
    time.minute(rounded).second(0);
    time.subtract(MINUTES_OFFSET, 'minutes');
    var updatedTimeValue = formatTimeString(time.hours(), time.minutes());
    setTimeValue(updatedTimeValue);
    onChange(updatedTimeValue);
  };

  var inputClassName = inputProps.className;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, remainingProps, {
    className: (0, _classnames.default)('TimePicker', 'input-group', className)
  }), showIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: "input-group-addon"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "rioglyph rioglyph-time-alt"
  })), /*#__PURE__*/_react.default.createElement(_reactInputMask.default, (0, _extends2.default)({}, inputProps, {
    className: (0, _classnames.default)('TimePickerInput', 'form-control', inputClassName),
    mask: mask,
    maskPlaceholder: '-',
    value: timeValue,
    onChange: handleChangeTime,
    alwaysShowMask: alwaysShowMask
  })), isValid && /*#__PURE__*/_react.default.createElement("div", {
    className: 'TimePickerIncreaseButton input-group-addon'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'text-color-gray hover-text-color-dark',
    onClick: handleDecrease
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'rioglyph rioglyph-chevron-left scale-90'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: 'text-color-gray hover-text-color-dark margin-left-5',
    onClick: handleIncrease
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'rioglyph rioglyph-chevron-right scale-90'
  }))));
};

TimePicker.defaultProps = {
  onChange: function onChange() {},
  alwaysShowMask: true,
  showIcon: false,
  className: '',
  inputProps: {}
};
TimePicker.propTypes = {
  onChange: _propTypes.default.func,
  value: _propTypes.default.string,
  alwaysShowMask: _propTypes.default.bool,
  showIcon: _propTypes.default.bool,
  className: _propTypes.default.string,
  inputProps: _propTypes.default.shape({
    className: _propTypes.default.string
  })
};
var _default = TimePicker;
exports.default = _default;